import { Component, OnInit, Input } from '@angular/core';
import { _ } from 'underscore';
import {
  trigger,
  state,
  style,
  animate,
  transition,
  group
} from '@angular/animations';
import { CommercialService } from '../../commercial.service';

@Component({
  selector: 'app-cq5',
  templateUrl: './cq5.component.html',
  styleUrls: ['./cq5.component.css', '../commercial-questionnaire.component.css'],
  animations: [
    trigger('flyInOut', [
      state('in', style({
        transform: 'translateX(0)', opacity: 1
      })),
      transition('void => *', [
        style({transform: 'translateX(100px)', opacity: 0 }),
        group([
          animate('0.4s 0.1s ease', style({
            transform: 'translateX(0)',
          })),
          animate('0.4s ease', style({
            opacity: 1
          }))
        ])
      ]),
      transition('* => void', [
        group([
          animate('0.4s ease', style({
            transform: 'translateX(50px)',
          })),
          animate('0.4s 0.2s ease', style({
            opacity: 0
          }))
        ])
      ])
    ])
  ]
})
export class Cq5Component implements OnInit {

  @Input() data: any;
  hgValue;
  lease_own;
  question;
  isChecked = false;
  showbutton = true;
  questions;
  userResponses = [];
  index;
  questionObj;
  messagetype;
  deviceWidth;
  user_bot = false;
  option1;
  option2;
  lease_src = 'assets/images/rent-gray.png';
  own_src = 'assets/images/own-gray.png';
  timer;
  location_responses = [];
  time = 3000;
  showTyping = false;

  constructor(private commercialService: CommercialService) {
    this.questions = this.commercialService.getQues();
    this.userResponses = this.commercialService.userResponse.userResponses;
    this.deviceWidth = this.commercialService.deviceWidth;
    this.hgValue = {
      value1: false,
      value2: false
    };
  }

  goNext() {
    clearTimeout(this.timer);
    if (this.deviceWidth < 768) {
      this.timer = setTimeout(() => {
        this.next();
      }, 1000);
    }
  }

  typingNext() {
    clearTimeout(this.timer);
    if (this.deviceWidth < 768) {
      this.commercialService.unSelectService({'currentId': this.data});
      this.showTyping = true;
      this.timer = setTimeout(() => {
        this.showTyping = false;
        this.next();
      }, this.time);
    }
  }

  ngOnInit() {
    this.commercialService.currentId = this.data;
    if (this.deviceWidth < 768) {
      this.option1 = document.getElementById('Lease_mob');
      this.option2 = document.getElementById('Own_mob');
    } else {
      this.option1 = document.getElementById('Lease');
      this.option2 = document.getElementById('Own');
    }
    for (let i = 0; i < this.questions.length; i++) {
      if (this.questions[i]._id === this.data) {
        this.question = this.questions[i].com_question;
        this.questionObj = this.questions[i];
        this.index = i;
      }
    }

    if (this.userResponses.length > 0 && !_.isEmpty(this.questionObj)) {
      const obj = _.findWhere(this.userResponses, { 'com_question_id': this.questionObj._id });
      if (!_.isEmpty(obj)) {
        if (!_.isEmpty(obj.fieldValue)) {
          this.location_responses = obj.fieldValue;
          if (!_.isEmpty(this.location_responses) && !this.commercialService.addAddress) {
            let index;
            if (this.commercialService.serialNumber !== null) {
              index = this.commercialService.serialNumber;
            } else if (this.commercialService.serialNumber === null) {
              index = 0;
            }
            if (!_.isEmpty(this.location_responses[index])) {
              this.lease_own = this.location_responses[index].value;
            }
            if (!_.isEmpty(this.lease_own)) {
              this.isChecked = true;
              if (this.lease_own === 'Lease') {
                this.lease_src = 'assets/images/rent-purple.png';
                this.own_src = 'assets/images/own-gray.png';
                this.hgValue = {
                  value1: true,
                  value2: false
                };
                this.option1.parentElement.parentElement.classList.add('active-select');
              } else if (this.lease_own === 'Own') {
                this.lease_src = 'assets/images/rent-gray.png';
                this.own_src = 'assets/images/own-purple.png';
                this.hgValue = {
                  value1: false,
                  value2: true
                };
                this.option2.parentElement.parentElement.classList.add('active-select');
              }
              this.user_bot = true;
              if (this.deviceWidth < 768) {
                if (this.commercialService.modifyAddress) {
                  this.typingNext();
                } else {
                  this.goNext();
                }
              }
            } else {
              this.lease_src = 'assets/images/rent-gray.png';
              this.own_src = 'assets/images/own-gray.png';
            }
          } else {
            this.lease_src = 'assets/images/rent-gray.png';
            this.own_src = 'assets/images/own-gray.png';
          }
        } else {
          this.lease_src = 'assets/images/rent-gray.png';
          this.own_src = 'assets/images/own-gray.png';
        }
      } else {
        this.lease_src = 'assets/images/rent-gray.png';
        this.own_src = 'assets/images/own-gray.png';
      }
    }

    if(!this.hgValue.value1 && !this.hgValue.value2)
    {
      this.showbutton = false;
    }
  }

  getValue(event) {
    this.lease_own = event.target.value;
    this.isChecked = event.target.checked;
    if (this.isChecked === true) {
      if (this.deviceWidth < 768) {
        this.commercialService.unSelectService({'currentId': this.data});
      }
      if (this.lease_own === 'Lease') {
        this.lease_src = 'assets/images/rent-purple.png';
        this.own_src = 'assets/images/own-gray.png';
        this.hgValue = {
          value1: true,
          value2: false
        };
        this.option1.parentElement.parentElement.classList.add('active-select');
        if (_.contains(this.option2.parentElement.parentElement.classList, 'active-select')) {
          this.option2.parentElement.parentElement.classList.remove('active-select');
        }
      } else {
        this.lease_src = 'assets/images/rent-gray.png';
        this.own_src = 'assets/images/own-purple.png';
        this.hgValue = {
          value1: false,
          value2: true
        };
        this.option2.parentElement.parentElement.classList.add('active-select');
        if (_.contains(this.option1.parentElement.parentElement.classList, 'active-select')) {
          this.option1.parentElement.parentElement.classList.remove('active-select');
        }
      }
      this.user_bot = true;
      if (this.deviceWidth < 768) {
        this.goNext();
      }
    } else {
      this.lease_src = 'assets/images/rent-gray.png';
      this.own_src = 'assets/images/own-gray.png';
      this.hgValue = {
        value1: false,
        value2: false
      };
      this.lease_own = '';
      if (_.contains(this.option2.parentElement.parentElement.classList, 'active-select')) {
        this.option2.parentElement.parentElement.classList.remove('active-select');
      }
      if (_.contains(this.option1.parentElement.parentElement.classList, 'active-select')) {
        this.option1.parentElement.parentElement.classList.remove('active-select');
      }
      if (this.deviceWidth < 768) {
        this.commercialService.unSelectService({'currentId': this.data});
      }
      this.user_bot = false;
    }
    this.save();

    
    if (this.isChecked === true)
    {
      if (this.deviceWidth < 768) {
       
      }else
      {
        if(!this.showbutton)
        {
          this.next();
        }
  
      }

    }
  }

  next() {
    if (_.isEmpty(this.lease_own)) {
      if (this.deviceWidth < 768) {
        this.commercialService.unSelectService({'currentId': this.data});
      }
    } else {
      this.commercialService.messageService({ 'currentId': this.data });
    }
  }
  // This function is used for to save the data in DB
  save() {
    if (this.commercialService.serialNumber !== null) {
      this.location_responses[this.commercialService.serialNumber] = {'serialNo': this.commercialService.serialNumber + 1, 'value': this.lease_own};
    } else if(this.commercialService.serialNumber === null) {
      this.location_responses.push({'serialNo': this.location_responses.length, 'value': this.lease_own});
    }
    const Obj = {
      'com_question_id': this.data, 'fieldName': 'lease_own', 'fieldValue': this.location_responses
    };
    this.commercialService.updateResponses(Obj);
  }
  
}
